import { useState } from "react";
import "./EditProfile.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import profile, { editprofile } from "../../service/Mainservice";
import { useEffect } from "react";
import { Snackbar } from "@mui/material";
import { Alert } from "@mui/material";
// import profileimg from "../../assets/agent (2).png";

const Editprofile = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [error, seterror] = useState();
  const [loading, setloading] = useState(false);

  const [success, setsuccess] = useState();
  const [preview, setPreview] = useState();
  const [image, setImage] = useState();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  // const full_name = "Admin";
  // const email = "admin@gmail.com";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profiledata = await profile();
        console.log(profiledata);
        setData({
          email: profiledata.data.data[0].email,
          fullName: profiledata.data.data[0].fullName,
          mobilenumber: profiledata.data.data[0].mobilenumber,
          image: profiledata.data.data[0].image,
        });
      } catch (error) {
        if (error.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      }
    };
    fetchData();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const handleClose2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen2(false);
  };

  const handlechange = (e) => {
    const { name, value } = e.target;
    setData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const imagehandle = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };

  console.log(data);

  const handleEdit = async () => {
    setloading(true);
    try {
      const editdata = await editprofile(data, image);
      setloading(false);
      setsuccess(editdata.data.message);
      setOpen2(true);

      const user = JSON.parse(localStorage.getItem("Data"));
      console.log(user);
      user.fullName = editdata.data.user.fullName;
      user.image = editdata.data.user.image;
      user.email = editdata.data.user.email;
      user.mobilenumber = editdata.data.user.mobilenumber;
      console.log(user);

      localStorage.setItem("Data", JSON.stringify(user));
    } catch (error) {
      setloading(false);

      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      seterror(error.message);
      setOpen(true);
    }
  };

  return (
    <>
      <div className="profileoptions">
        <li>
          <Link to="/Profile">Profile Info</Link>
        </li>
        <li className="active_profile">
          <Link to="/EditProfile">Update Profile</Link>
        </li>
        <li>
          <Link to="/ChangePassword">Change Password</Link>
        </li>
      </div>

      <div className="editdata">
        <div className="edit_profileimg">
          {preview ? (
            <img src={preview} alt="profile" className="editprofile_img" />
          ) : (
            <img
              src={data.image}
              alt="editprofile_image"
              className="editprofile_img"
            />
          )}

          <input
            type="file"
            id="file"
            accept="image/*"
            onChange={imagehandle}
            name="profile_pic"
          />
          <label htmlFor="file" id="uploadbtn">
            <CameraAltIcon className="edit_cameraicn" />
          </label>
        </div>

        <div className="edit_input">
          <label className="Auth_label">Username</label>
          <br />

          <input
            onChange={handlechange}
            name="fullName"
            type="text"
            className="Auth_input"
            placeholder="Name"
            minLength={1}
            maxLength={30}
            value={data.fullName}
            required
          />
        </div>
        <div className="edit_input">
          <label className="Auth_label">Mobile Number</label>
          <br />

          <input
            onChange={handlechange}
            name="mobilenumber"
            type="number"
            className="Auth_input"
            placeholder="Number"
            minLength={1}
            maxLength={30}
            value={data.mobilenumber}
            required
          />
        </div>
        <div className="edit_input">
          <label className="Auth_label">Email</label>
          <br />

          <input
            onChange={handlechange}
            name="email"
            style={{ outline: "none" }}
            type="email"
            placeholder="Email"
            className="Auth_input"
            minLength={10}
            maxLength={50}
            value={data.email}
          />
        </div>
        <button className="edit_button" disabled={loading} onClick={handleEdit}>
          {loading ? "Loading...." : "Save"}
        </button>
        <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert variant="filled" severity="error">
            {error}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};
export default Editprofile;
